import { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, Container } from "@mui/material";

import Bar from "./Bar";
import Navigation from "./Navigation";
import { useAppSelector } from "../../app/hooks";

function Layout() {
  const [height, setHeight] = useState<number | null>(null);
  const ref = useRef<HTMLDivElement>(null);

  const resize = () => {
    if (ref.current) {
      setHeight(
        document.documentElement.clientHeight - ref.current.offsetHeight
      );
    }
  };

  useEffect(() => {
    resize();

    window.addEventListener("resize", resize);

    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  const loggedIn = useAppSelector((state) => state.auth.loggedIn);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Bar withRef={ref} />
      <Container
        sx={{
          minHeight: `${height}px`,
          padding: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 4,
        }}
      >
        {loggedIn && <Navigation />}

        <Outlet />
      </Container>
    </Box>
  );
}

export default Layout;
